import { Navigate } from "react-router-dom";
import Logout from "src/modules/logout";
import CompanyDashboard from 'src/modules/company-dashboard/pages/company-dashboard';
import MainLayout from "../../components/MainLayout";
import Admins from "../../modules/admins/pages/main";
import Login from "../../modules/login/pages/main";
import Auth from "../../modules/auth/pages/main";
import NotFound from "../../modules/not-found/pages/main";
import DashboardLayout from "../../components/DashboardLayout";
import Dashboard from "../../modules/dashboard/pages/main";
import Approvals from "../../modules/approvals/pages/main";
import Companies from "../../modules/companies/pages/main";
import PartnersAndResellers from "../../modules/partners-and-resellers/pages/main";
import EmailLog from "../../modules/email-log/pages/main";
import MasterControl from "../../modules/master-control/pages/main";
import ConsumerEngagement from "../../modules/consumer-engagement/pages/main";
import Bundles from "../../modules/bundles/pages/main";
import DataSummary from "../../modules/data-summary/pages/main";
import SupportTicketList from "../../modules/support/pages/ticket-list";
import SupportTicketDetail from "../../modules/support/pages/ticket-detail";
import SupportAnalytics from "../../modules/support/pages/analytics";
import SupportSlaSettings from "../../modules/support/pages/sla-settings";
import ManagementSn from "../../modules/management-sn/pages/main";
import SupportCreateTicket from "../../modules/support/pages/create-ticket";

const routes = [
  {
    path: "",
    element: <MainLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "auth", element: <Auth /> },
      { path: "", element: <Navigate to="/login" /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "admin",
    element: <DashboardLayout />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "approvals", element: <Approvals /> },
      { path: "companies", element: <Companies /> },
      { path: "companies/:companyId", element: <CompanyDashboard /> },
      { path: "bundles", element: <Bundles /> },
      { path: "consumer-engagement", element: <ConsumerEngagement /> },
      { path: "partners-and-resellers", element: <PartnersAndResellers /> },
      { path: "email-log", element: <EmailLog /> },
      { path: "master-control", element: <MasterControl /> },
      { path: "data-summary", element: <DataSummary /> },
      { path: "support", element: <SupportTicketList /> },
      { path: "support/create", element: <SupportCreateTicket /> },
      { path: "support/tickets/:id", element: <SupportTicketDetail /> },
      { path: "support/analytics", element: <SupportAnalytics /> },
      { path: "support/sla-settings", element: <SupportSlaSettings /> },
      { path: "admins", element: <Admins /> },
      { path: "management-sn", element: <ManagementSn /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  { path: "logout", element: <Logout /> },
  { path: "404", element: <NotFound /> },
];

export default routes;
